<template>
  <component :class="cn('size-6', props.class)" :is="icon" />
</template>

<script setup lang="ts">
import { cn } from '@/lib/utils';
import * as solid from '@heroicons/vue/solid';
import * as outline from '@heroicons/vue/outline';

const props = defineProps<{
  name: string;
  outline?: boolean;
  class?: string;
}>();

const icons = computed(() => ({ solid, outline }));

function buildIconComponentName(iconName: string): string {  
  if (!iconName || typeof iconName !== 'string' ) return '';
  // If the iconName already ends with 'Icon', assume it's valid and return it as is.
  if (iconName.endsWith('Icon')) {
    return iconName;
  }
  // Otherwise, transform the name to the expected format.
  return iconName.replace(/(^\w|-\w)/g, match => match.replace(/-/, '').toUpperCase()) + 'Icon';
}

const icon = computed(() => icons.value[props.outline ? 'outline' : 'solid'][buildIconComponentName(props.name)]);
</script>
